/** Site-wide photo upload status so every surface can show shared progress. */

export type PhotoUploadStatus = {
  id: string;
  label: string;
  percent: number;
};

type Listener = () => void;

const listeners = new Set<Listener>();
const active = new Map<string, PhotoUploadStatus>();
let snapshot: PhotoUploadStatus | null = null;

function publish() {
  const next = [...active.values()].at(-1) ?? null;
  snapshot = next;
  for (const listener of listeners) listener();
}

export function subscribePhotoUploadProgress(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getPhotoUploadProgress() {
  return snapshot;
}

export function beginPhotoUpload(id: string, label: string, percent = 0) {
  active.set(id, { id, label, percent: Math.max(0, Math.min(100, Math.round(percent))) });
  publish();
}

export function updatePhotoUpload(id: string, label: string, percent: number) {
  if (!active.has(id)) return;
  active.set(id, { id, label, percent: Math.max(0, Math.min(100, Math.round(percent))) });
  publish();
}

export function endPhotoUpload(id: string) {
  if (!active.delete(id)) return;
  publish();
}
